
import BtnReadmore from '~/components/common/btn-readmore.vue'
import TopSectionTitle from '~/components/common/TopSectionTitle.vue'

export default {
  components: {
    BtnReadmore,
    TopSectionTitle
  }
}
